import { ComponentType } from 'react'

import { useAuthStore } from '@/store/auth-store'
import { UnfinishedLogsTable } from './components/controller/UnfinishedLogsTable'
import { UpdatedRecordsTable } from './components/UpdatedRecordsTable'
import { Role } from '@/types/auth'

import styles from './UnfinishedRecords.module.scss'

const COMPONENTS_MAP: Partial<Record<Role, ComponentType<any>>> = {
    [Role.MileageClerk]: UpdatedRecordsTable,
    [Role.Controller]: UnfinishedLogsTable,
}

export const UnfinishedRecords = () => {
    const { role } = useAuthStore()

    const Component = role && COMPONENTS_MAP[role]

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <h1 className={styles.title}>
                    {role === Role.MileageClerk ? 'Updated records' : 'Unfinished records'}
                </h1>
            </header>
            <div className={styles.container}>{Component && <Component displayTableHeader />}</div>
        </section>
    )
}
